import React from 'react';
import { styled } from 'linaria/react';
import { useToast } from '@shared/lib/toast';
import { Toast } from '@shared/ui/organisms';
import { useIsClient } from '@shared/lib/react';
const ToastContainer: React.FC = () => {
  const {
    toasts,
    dismiss
  } = useToast();
  const isClient = useIsClient();
  if (!isClient) {
    return null;
  }
  return <Container>
      {toasts.map(toast => <Toast key={toast.id} {...toast} onDismiss={dismiss} />)}
    </Container>;
};
export default ToastContainer;
const Container = /*#__PURE__*/styled('div')({
  name: "Container",
  class: "clh0z9p",
  propsAsIs: false
});

require("./ToastContainer.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ToastContainer.tsx");